module.exports = __webpack_public_path__ + "img/QA.57615956.svg";